var map = {
	"./CAD": [
		"QmAk",
		16
	],
	"./CAD.js": [
		"QmAk",
		16
	],
	"./EUR": [
		"KjxY",
		17
	],
	"./EUR.js": [
		"KjxY",
		17
	],
	"./GBP": [
		"PuwP",
		18
	],
	"./GBP.js": [
		"PuwP",
		18
	],
	"./SEK": [
		"hnT/",
		19
	],
	"./SEK.js": [
		"hnT/",
		19
	],
	"./USD": [
		"+gRZ",
		20
	],
	"./USD.js": [
		"+gRZ",
		20
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "ytBX";
module.exports = webpackAsyncContext;